var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeedometer = function SvgSpeedometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.664 14.667C.664 6.755 7.085.333 14.997.333c7.913 0 14.334 6.422 14.334 14.334 0 3.898-1.563 7.454-4.1 10.034a1 1 0 1 1-1.427-1.402 12.286 12.286 0 0 0 3.527-8.632c0-6.808-5.526-12.334-12.334-12.334-6.807 0-12.333 5.526-12.333 12.334 0 3.355 1.33 6.388 3.504 8.623a1 1 0 0 1-1.434 1.394 14.312 14.312 0 0 1-4.07-10.017Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.999 18.653a3.507 3.507 0 1 0 0 7.014 3.507 3.507 0 0 0 0-7.014ZM9.492 22.16a5.507 5.507 0 1 1 11.014 0 5.507 5.507 0 0 1-11.014 0ZM17.328 12c0-1.663 1.359-3 3-3 1.646 0 3 1.354 3 3 0 1.663-1.359 3-3 3h-1c-1.099 0-2-.901-2-2v-1Zm3-1c-.545 0-1 .45-1 1v1h1c.546 0 1-.45 1-1 0-.541-.459-1-1-1Z",
    fill: "#123862"
  })));
};
export default SvgSpeedometer;